import script from "./SocionicsVsMBTI.vue?vue&type=script&setup=true&lang=js"
export * from "./SocionicsVsMBTI.vue?vue&type=script&setup=true&lang=js"

import "./SocionicsVsMBTI.vue?vue&type=style&index=0&id=01123c96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01123c96"]])

export default __exports__